import React, { useState, useRef, useEffect } from 'react'

import Field from '../../Field/Field'
import TextInput from '../../TextInput/TextInput'
import Textarea from '../../Textarea/Textarea'
import Tooltip from '../../Tooltip/Tooltip'
import FieldLabel from '../../FieldLabel/FieldLabel'
import Checkbox from '../../Checkbox/Checkbox'
import Radio from '../../Radio'
import Help from '../../Help/Help'
import Datepicker from '../../Datepicker/Datepicker'
import InfoModal from '../../InfoModal/InfoModal'
import TimePicker2 from '../../Timepicker/TimePicker2'

import DateTimepicker2 from '../../DateTimepicker/DateTimepicker2'
import { defaultTimezone } from '../../DateTime/helper'
import DSTTimeZoneList from '../../DateTime/TimeZoneList'
import { ToggleSwitch } from '../../..'

import { fieldUidRegex, getContentTypeFieldDataTestId, CONTENT_TYPE_FIELD_ACTION_IDS, NonLocalizableDom, handleToggleClick } from '../helper'
import { format } from 'date-fns'
import { booleanTestIdFormatter } from './../../../utils/helpers'
import GroupFieldTitleToggle from "../HelperComponents/GroupFieldTitleToggle"

const getFormattedDate = (datePickerValue: any) => {
  let dateValueFormatted = datePickerValue ? datePickerValue?.split('-') : '';
  if (dateValueFormatted && dateValueFormatted.length) {
    const seperator = (navigator?.userAgent?.indexOf('Safari') != -1 && navigator?.userAgent?.indexOf('Chrome') == -1) ? '/' : '-'
    dateValueFormatted = `${dateValueFormatted[1]}${seperator}${dateValueFormatted[2]}${seperator}${dateValueFormatted[0]}`;
  }
  return dateValueFormatted ? dateValueFormatted : ''
}

export const DateField = (props: any) => {
  const { onChange, parentInfo, uniqueKey, schema, type, isNonLocalizable, hasNonLocalizablePlan, hasNonLocalizablePlanForBlocksAndGroupMultiple } = props
  const [, setSchema] = useState(schema)
  const { display_name, uid, field_metadata } = schema
  const [error, setError] = useState(fieldUidRegex(schema.uid, schema))

  let todaydate = new Date()
  let foundZone = DSTTimeZoneList().find((singleZoneObj) => defaultTimezone('') === singleZoneObj.value)
  let foundZoneVal = foundZone ? foundZone.offsetString : `${new Date().toString().split('GMT')[1].split(' (')[0]}`
  console.log('foundZone ', foundZone, foundZoneVal)
  let newDate: any = `${todaydate.getFullYear()}-${todaydate.getMonth() + 1}-${todaydate.getDate()}`
  let newTime: any = '00:00:00' + foundZoneVal

  if (schema.field_metadata && schema.field_metadata.default_value && schema.field_metadata.default_value.date) {
    newDate = new Date(schema.field_metadata.default_value.date)
  }
  if (schema.field_metadata && schema.field_metadata.default_value && schema.field_metadata.default_value.time) {
    newTime = schema.field_metadata.default_value.time
  }

  //custom date
  const [customDateVal, setCustomDate] = useState('')
  const [customTimeVal, setCustomTime] = useState('')

  const displayNameRef: any = useRef(null)

  useEffect(() => {
    displayNameRef?.current?.focus()
  }, [displayNameRef])

  const onchange = (triggerSetSchema: boolean = true) => {
    onChange && onChange(schema)
    triggerSetSchema && setSchema({ ...schema })
  }
  // const { schema, onChange, uniqueKey } = props
  // const { display_name, uid, field_metadata, error_messages = {} } = schema
  // const onchange = () => {
  //   onChange && onChange(schema)
  // }
  const onDisplayNameChange = (event: any) => {
    schema.display_name = event.target.value

    if (schema.hasOwnProperty('display_name') && schema.newfield) {
      schema.uid = schema.display_name
        .trim()
        .replace(/[^A-Z0-9]+/gi, '_')
        .toLowerCase()
      if (schema.display_name) {
        schema.error_details = {
          ...schema.error_details,
          uid: ''
        }
      }
    }

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.display_name.length) {
      schema.error_details = {
        ...schema.error_details,
        display_name: 'Display Name cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        display_name: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onUidChange = (event: any) => {
    setError(fieldUidRegex(event.target?.value?.trim(), schema))

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.uid.length) {
      schema.error_details = {
        ...schema.error_details,
        uid: 'uid cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        uid: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onInstructionChange = (event: any) => {
    field_metadata.instruction = event.target.value
    onchange()
  }
  const onHelpTextChange = (event: any) => {
    field_metadata.description = event.target.value
    onchange()
  }
  const onOptionsChange = (event: any) => {
    if (event.target.name === `${uniqueKey}.mandatory`) {
      schema.mandatory = event.target.checked
    }
    if (event.target.name === `${uniqueKey}.hideTime`) {
      if (event.target.checked) {
        field_metadata.hide_time = true
        if (schema.startDate) {
          schema.startDate = schema.startDate.split('T')[0]
        }
        if (schema.endDate) {
          schema.endDate = schema.endDate.split('T')[0]
        }
      } else {
        field_metadata.hide_time = false
        if (schema.startDate) {
          schema.startDate = schema.startDate + 'T' + newTime
        }
        if (schema.endDate) {
          schema.endDate = schema.endDate + 'T' + newTime
        }
      }
    }
    if (event.target.name === `${uniqueKey}.setDateRange`) {
      field_metadata.date_range = event.target.checked
    }
    if (event.target.name === `${uniqueKey}.multiple`) {
      if (event.target.checked) field_metadata.isTitle = false;
      schema.multiple = event.target.checked
      schema.error_details = {
        ...schema.error_details,
        max_instance: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
      console.log('Error Date ', schema)
      if (!schema.multiple) {
        delete schema.max_instance
      }
    }
    if (event.target.name === `${uniqueKey}.nonLocalization`) {
      if (event.target.checked && parentInfo.hasParent && hasNonLocalizablePlanForBlocksAndGroupMultiple) {
        handleToggleClick(event, parentInfo.data_type, schema, onchange, 'nonLocalizable', props.t , parentInfo.isInsideMultiple ,parentInfo.ancestorWithMultipleType)
      }
      else {
        schema.non_localizable = event.target.checked
      }
    }
    onchange()
  }
  const onDefaultValueChange = (event: any) => {
    if (event.target.value === 'createdDate') {
      schema.field_metadata.default_value = { custom: false, date: '', time: '' }
    }
    if (event.target.value === 'customDate') {
      schema.field_metadata.default_value = { custom: true, date: customDateVal, time: customTimeVal }
    }
    onchange()
  }
  const onStartDateChangeHandler = (date: any) => {
    schema.startDate = date
    if (schema.startDate && schema.endDate) {
      let date1 = schema.startDate
      let date2 = schema.endDate
      if (date2 < date1) {
        schema.error_details = {
          ...schema.error_details,
          start_date: 'Start Date cannot be greater than End Date'
        }
        schema.error = true
      } else {
        schema.error_details = {
          ...schema.error_details,
          start_date: ''
        }
        schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
          ? true
          : false
      }
    }

    onchange(false)
  }
  const onEndDateChangeHandler = (date: any) => {
    schema.endDate = date

    if (schema.startDate && schema.endDate) {
      let date1 = schema.startDate
      let date2 = schema.endDate
      if (date2 < date1) {
        schema.error_details = {
          ...schema.error_details,
          end_date: 'End Date cannot be less than Start Date'
        }
        schema.error = true
      } else {
        schema.error_details = {
          ...schema.error_details,
          end_date: ''
        }
        schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
          ? true
          : false
      }
    }
    onchange(false)
  }


  const onMaxInstance = (event: any) => {
    schema.max_instance = event.target.value ? parseInt(event.target.value) : null

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (event.target.value.length && schema.max_instance < 0) {
      schema.error_details = {
        ...schema.error_details,
        max_instance: 'max instance cannot be less then zero'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        max_instance: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }

    onchange()
  }

  if (type === 'basic') {
    return (
      <div className="FormFields">
        <Field>
          <FieldLabel className='FieldLabel__CT' testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}-label`} version='v2' required htmlFor="displayName">
            Display Name
          </FieldLabel>
          <TextInput
            version='v2'
            required
            name={`${uniqueKey}.displayName`}
            value={display_name}
            inputRef={displayNameRef}
            onChange={onDisplayNameChange}
            error={schema.error && schema.error_details.display_name ? true : false}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel className='FieldLabel__CT' testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}-label`} version='v2' required htmlFor="uid">
            Unique ID
          </FieldLabel>
          <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}-help-text`} text="A unique ID for this field. This should not be same as the ID of any other field in this content type." />
          <TextInput
            version='v2'
            required
            name={`${uniqueKey}.uid`}
            value={uid}
            onChange={onUidChange}
            error={(schema.error && schema.error_details.uid) || error ? true : false}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel className='FieldLabel__CT' version='v2' testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}-label`} htmlFor="instruction">Instruction Value</FieldLabel>
          <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}-help-text`} text="Helps you add instructions for this field. The instructional text will appear below the field." />
          <Textarea
            version='v2'
            name={`${uniqueKey}.instruction`}
            value={field_metadata.instruction || ''}
            onChange={onInstructionChange}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            // multiline={true}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
            id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel className='FieldLabel__CT' testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}-label`} version='v2' htmlFor="helpText">Help Text</FieldLabel>
          <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}-help-text`} text="Provide additional info about the field. The help text will appear when the user hovers on the ‘?’ sign beside the field name." />
          <Textarea
            version='v2'
            name={`${uniqueKey}.helpText`}
            value={field_metadata.description || ''}
            onChange={onHelpTextChange}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            // multiline={true}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
            id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
          />
        </Field>
      </div>
    )
  } else if (type === 'advanced') {


    let tempStart: any = schema?.startDate?.includes('T') ? schema?.startDate?.split('T')[0] : schema?.startDate
    let tempEnd: any = schema?.endDate?.includes('T') ? schema?.endDate?.split('T')[0] : schema?.endDate

    const startDateObj = {
      date: format(schema.startDate ? new Date(getFormattedDate(tempStart)) : new Date(), "yyyy-MM-dd"),
      time: schema.startDate ? format(new Date(tempStart), "HH:mm:ssxx") : ("00:00:00" + foundZoneVal)
    }
    const endDateObj = {
      date: format(schema.endDate ? new Date(getFormattedDate(tempEnd)) : new Date(), "yyyy-MM-dd"),
      time: schema.endDate ? format(new Date(tempEnd), "HH:mm:ssxx") : ("00:00:00" + foundZoneVal)
    }

    return (
      <div className="FormFields">

        <Field>
          <FieldLabel testId='cs-ctf-date-advanced-default-label' version='v2' htmlFor="defaultValue">Default Value</FieldLabel>
          <Help type="basic" testId='cs-ctf-date-advanced-default-help-text' text="Set a default field value for this field. The value will appear by default while creating an entry for this content type." />
          <div className="FormFields__selection-wrapper">
            {field_metadata?.default_value && Object.keys(field_metadata.default_value).includes('custom') ? (
              <>
                <Radio
                  testId="cs-ct-field-date-created-date"
                  radioDisplayType="block"
                  name={`${uniqueKey}.defaultValue`}
                  text="Created Date"
                  checked={!field_metadata?.default_value?.custom}
                  value="createdDate"
                  onChange={onDefaultValueChange}
                />
                <Radio
                  testId="cs-ct-field-date-custom-date"
                  radioDisplayType="block"
                  name={`${uniqueKey}.defaultValue`}
                  text="Custom Date"
                  checked={field_metadata?.default_value?.custom}
                  value="customDate"
                  onChange={onDefaultValueChange}
                />
              </>
            ) : (
              <>
                <Radio
                  testId="cs-ct-field-date-created-date"
                  radioDisplayType="block"
                  name={`${uniqueKey}.defaultValue`}
                  text="Created Date"
                  checked={false}
                  value="createdDate"
                  onChange={onDefaultValueChange}
                />
                <Radio
                  testId="cs-ct-field-date-custom-date"
                  radioDisplayType="block"
                  name={`${uniqueKey}.defaultValue`}
                  text="Custom Date"
                  checked={false}
                  value="customDate"
                  onChange={onDefaultValueChange}
                />
              </>
            )}
          </div>
        </Field>
        {field_metadata?.default_value?.custom ? (
          <Field>
            <FieldLabel className='FieldLabel__CT' testId='cs-ctf-date-advanced-timestamp-label' version='v2' htmlFor='timestamp'>
              Time Stamp
            </FieldLabel>
            <div className='flex-v-center flex-wrap' style={{ gap: "16px" }}>
              <Datepicker
                testId='cs-ct-field-date-customDate'
                initialDate={field_metadata.default_value.date || customDateVal}
                onChange={(date) => {
                  const dt = format(new Date(date), "yyyy-MM-dd")
                  console.log('you change date', date, dt)
                  field_metadata.default_value.date = dt
                  onchange()
                  setCustomDate(dt)
                }}
                viewType="date"
                version='v2'
                withFooter={true}
                formatType='MM dd yyyy'
                inputMaskProps={{
                  inputMaskWidth: 160,
                  placeholder: 'mm-dd-yyyy',
                  inputMaskTestId: 'cs-ct-field-date-customDate-input'
                }}
              />
              {!field_metadata.hide_time && (
                <TimePicker2
                  testId='cs-ct-field-date-customTime'
                  inputMaskTestId='cs-ct-field-date-customTime-input'
                  initialDate={field_metadata.default_value.time || customTimeVal}
                  onChange={(time) => {
                    console.log('you changed time', time)
                    field_metadata.default_value.time = time
                    onchange(false)
                  }}
                  onDone={(time) => {
                    console.log('on date component done time', time)
                    field_metadata.default_value.time = time
                    onchange(false)
                    setCustomTime(time)
                  }}
                  inputDisabled={false}
                  placeholder="Select time"
                  viewType="time"
                  shouldTimePickerModalOpen={true}
                  version='v2'
                  timePickerWidth={160}
                  timezoneWidth={280}
                />)}
            </div>
          </Field>
        ) : null}
        <Field>
          <FieldLabel version='v2' htmlFor="options">Options</FieldLabel>
          <div className="FormFields__selection-wrapper">
            <div className='ToggleWrap'>
              <ToggleSwitch
                testId={booleanTestIdFormatter("cs-ct-field-date-mandatory", schema.mandatory)}
                name={`${uniqueKey}.mandatory`}
                label="Mandatory"
                checked={schema.mandatory}
                onChange={onOptionsChange}
              />
            </div>
            <div className='ToggleWrap'>
              <ToggleSwitch
                testId={booleanTestIdFormatter("cs-ct-field-date-hide-time", field_metadata.hide_time || false)}
                name={`${uniqueKey}.hideTime`}
                label="Hide Time"
                checked={field_metadata.hide_time || false}
                onChange={onOptionsChange}
              />
            </div>
            <div className="ToggleWrap">
              <ToggleSwitch
                testId={booleanTestIdFormatter("cs-ct-field-date-set-date-range", field_metadata.date_range || false)}
                name={`${uniqueKey}.setDateRange`}
                label="Set Date Range"
                checked={field_metadata.date_range || false}
                onChange={onOptionsChange}
              />
              <span className='ml-8'>
                <Help type="basic" text="Set range of date (start and end) that the user will be allowed to select from." />
              </span>
            </div>
            {field_metadata.date_range
              ?
              (
                <>
                  <Field className='mr-16'>
                    <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.START_DATE_TEXT_INPUT)}-label`} version='v2' className="FieldLabel__CT" htmlFor="startDate">
                      Time Stamp - Start Date
                    </FieldLabel>
                    <div className='flex-v-center flex-wrap' style={{ gap: "16px" }} >
                      <Datepicker
                        testId='cs-ct-field-date-set-start-date'
                        initialDate={startDateObj.date}
                        onChange={(date) => {
                          const selectedDT = format(new Date(date), 'yyyy-MM-dd')
                          if (field_metadata.hide_time) {
                            onStartDateChangeHandler(`${selectedDT}`)
                          } else {
                            onStartDateChangeHandler(`${selectedDT}T${startDateObj.time}`)
                          }
                        }}
                        viewType="date"
                        version='v2'
                        withFooter={true}
                        formatType='MM dd yyyy'
                        inputMaskProps={{ inputMaskWidth: 160, inputMaskTestId: 'cs-ct-field-date-set-start-date-input' }}
                        errorBorder={schema.error && !!schema.error_details.start_date}
                      />
                      {field_metadata.hide_time ? null
                        : <TimePicker2
                          testId='cs-ct-field-date-set-start-time'
                          inputMaskTestId='cs-ct-field-date-set-start-time-input'
                          initialDate={startDateObj.time}
                          onChange={(time) => {
                            const finalTime = `${format(new Date(startDateObj.date), "yyyy-MM-dd")}T${time}`
                            onStartDateChangeHandler(finalTime)
                          }}
                          onDone={(time) => {
                            const finalTime = `${format(new Date(startDateObj.date), "yyyy-MM-dd")}T${time}`
                            onStartDateChangeHandler(finalTime)
                          }}
                          inputDisabled={false}
                          placeholder="Select time"
                          viewType="time"
                          shouldTimePickerModalOpen={true}
                          version='v2'
                          timePickerWidth={160}
                          timezoneWidth={280}
                        />
                      }
                    </div>
                  </Field>
                  <Field>
                    <FieldLabel className='FieldLabel__CT' testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.END_DATE_TEXT_INPUT)}-label`} version='v2' htmlFor="endDate">
                      Time Stamp - End Date
                    </FieldLabel>
                    <div className='flex-v-center flex-wrap' style={{ gap: "16px" }} >
                      <Datepicker
                        testId='cs-ct-field-date-set-end-date'
                        initialDate={endDateObj.date}
                        onChange={(date) => {
                          const selectedDT = format(new Date(date), 'yyyy-MM-dd')
                          console.log("::: date", date, selectedDT)
                          if (field_metadata.hide_time) {
                            onEndDateChangeHandler(`${selectedDT}`)
                          } else {
                            onEndDateChangeHandler(`${selectedDT}T${endDateObj.time}`)
                          }
                        }}
                        viewType="date"
                        version='v2'
                        withFooter={true}
                        formatType='MM dd yyyy'
                        inputMaskProps={{ inputMaskWidth: 160, inputMaskTestId: 'cs-ct-field-date-set-end-date-input' }}
                        errorBorder={schema.error && !!schema.error_details.end_date}
                      />
                      {field_metadata.hide_time ? null
                        : <TimePicker2
                          testId='cs-ct-field-date-set-end-time'
                          inputMaskTestId='cs-ct-field-date-set-end-time-input'
                          initialDate={endDateObj.time}
                          onChange={(time) => {
                            const finalTime = `${format(new Date(endDateObj.date), "yyyy-MM-dd")}T${time}`
                            console.log("::: time", time)
                            onEndDateChangeHandler(finalTime)
                          }}
                          onDone={(time) => {
                            const finalTime = `${format(new Date(endDateObj.date), "yyyy-MM-dd")}T${time}`
                            console.log("::: time", time)
                            onEndDateChangeHandler(finalTime)
                          }}
                          inputDisabled={false}
                          placeholder="Select time"
                          viewType="time"
                          shouldTimePickerModalOpen={true}
                          version='v2'
                          timePickerWidth={160}
                          timezoneWidth={280}
                        />
                      }
                    </div>
                  </Field>
                </>
              )
              : null}
            <div className='ToggleWrap'>
              <ToggleSwitch
                testId={booleanTestIdFormatter("cs-ct-field-date-multiple", schema.multiple)}
                name={`${uniqueKey}.multiple`}
                label="Multiple"
                checked={schema.multiple}
                onChange={onOptionsChange}
              />
            </div>
            {schema.multiple ? (
              <div>
                <Field className='ToggleWrap__sub_Field'>
                  <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SET_MAX_LIMIT_INPUT)}-label`} version='v2' className="FieldLabel__CT" htmlFor="validation">
                    Set Maximum Limit
                  </FieldLabel>
                  <TextInput
                    version='v2'
                    type="number"
                    name={`${uniqueKey}.maxinstance`}
                    value={schema.max_instance || null}
                    onChange={onMaxInstance}
                    // placeholder="Maximum"
                    placeholder={props.t(
                      'content_type.save_content_type.body.fields.common_properties.placeholders.maximum'
                    )}
                    error={schema.error && schema.max_instance ? true : false}
                    testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SET_MAX_LIMIT_INPUT)}
                  />
                </Field>
              </div>
            ) : null}
            {
              hasNonLocalizablePlan ? (
                hasNonLocalizablePlanForBlocksAndGroupMultiple ? (
                  <NonLocalizableDom
                    isFieldPresent={true}
                    uniqueKey={uniqueKey}
                    schema={schema}
                    onOptionsChange={onOptionsChange}
                    dataTestId={booleanTestIdFormatter(schema.nonLocParams?.insideMultiple ? `cs-ct-field-date-non-localizable-parent-multiple` : `cs-ct-field-date-non-localizable`, schema.non_localizable)}
                    dataTestIdForDescription={"cs-ct-field-date-non-localizable-description"}
                    isNonLocalizable={isNonLocalizable}
                    isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                  />
                ) : (parentInfo.hasParent ? !parentInfo.isInsideMultiple : true) ?
                  <NonLocalizableDom
                    isFieldPresent={true}
                    uniqueKey={uniqueKey}
                    schema={schema}
                    onOptionsChange={onOptionsChange}
                    dataTestId={booleanTestIdFormatter("cs-ct-field-date-non-localizable", schema.non_localizable)}
                    dataTestIdForDescription={"cs-ct-field-date-non-localizable-description"}
                    isNonLocalizable={isNonLocalizable}
                    isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                  />
                  : null
              ) : null
            }
          </div>
        </Field>
        <GroupFieldTitleToggle
          parentInfo={parentInfo}
          uniqueKey={uniqueKey}
          field_metadata={field_metadata}
          onchange={onchange}
          multiple={schema?.multiple}
          testId="cs-ct-field-date-group-title"
        />
      </div >
    )
  }
}

export default React.memo(DateField)
